import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserLogin } from '../model/user-login';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private route: Router) { }

  login(model: UserLogin) {
    return this.http.post(`${environment.baseUrl}/api/Account/login`, model, { observe: 'response' });
  }

  logout() {
    localStorage.clear();
    this.route.navigate(['/auth/login']);
  }
}
